module.exports = __webpack_public_path__ + "static/media/banner-photo1024.4702abf1.webp";